module.exports = __webpack_public_path__ + "img/orangeTopBg.8adf26ce.png";